import PropTypes from 'prop-types'
import styled from 'styled-components'

import breakpoints from '../../../lib/Breakpoints'
import colors from '../../../lib/Colors'

const StyledCard = styled.div`
  background: ${colors.white};
  width: 50%;
  min-height: 100px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  @media (max-width: ${breakpoints.tablet}) {
    width: 90%;
  }
`

const Card = ({ className, children }) => {
  return <StyledCard className={className}>{children}</StyledCard>
}

Card.propTypes = {
  children: PropTypes.any,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export default Card
